var _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 32 23",
    style: {
      enableBackground: "new 0 0 32 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,17c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S1.3,17,3,17z M3,19c-0.6,0-1,0.4-1,1s0.4,1,1,1 s1-0.4,1-1S3.6,19,3,19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S8.3,6,10,6z M10,8C9.4,8,9,8.4,9,9s0.4,1,1,1 c0.6,0,1-0.4,1-1S10.6,8,10,8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S20.3,12,22,12z M22,14c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S22.6,14,22,14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29,0c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S27.3,0,29,0z M29,2c-0.6,0-1,0.4-1,1s0.4,1,1,1 s1-0.4,1-1S29.6,2,29,2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26.7,4.6 28.4,5.7 23.3,13.4 21.6,12.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.3,11.1 12.2,9.3 20.2,13.4 19.3,15.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.6,10.8 10.3,11.9 5.3,19.7 3.6,18.6 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.50d34f617acbbf3c6362b1f1ffb95b33.svg";
export { ForwardRef as ReactComponent };